<div class="content-wrapper-inner relative">
  <app-disabled-section-widget [service]="'ntc'" (changeState)="serviceDisabled = !$event.service"></app-disabled-section-widget>
  <div *ngIf="serviceDisabled === false" class="page-content">
    <div class="table-topbar">
      <div class="search-holder">
        <h3>Scheduler</h3>
      </div>
      <div class="table-action-holder">
        <div class="create">
          <a (click)="onClickCreateSchedule()" class="btn btn-primary py-10 px-15"><span class="icon-add"></span>Create schedule</a>
        </div>
      </div>
    </div>
    <div class="scheduler-tabs">
      <button type="button" class="btn scheduler-tab" [class.active]="activeTasksView() === 'active'" (click)="onTasksViewChange('active')">
        Active
      </button>

      <button type="button" class="btn scheduler-tab" [class.active]="activeTasksView() === 'inactive'" (click)="onTasksViewChange('inactive')">
        Stopped & Completed
      </button>
    </div>
    <div class="d-flex justify-content-between align-items-center gap-10 second-top-bar">
      <app-scheduler-search class="flex-grow-1" [taskView]="activeTasksView()" (searchSubmit)="onSubmitSearchForm($event)"></app-scheduler-search>
      <div class="d-flex justify-content-between align-items-center right-side">
        @if (activeTasksView() === 'inactive') {
          <div class="d-flex justify-content-between align-items-center">
            <label class="label">
              <span
                class="icon icon-help-1 text-neutral-n6 me-0_2"
                tooltip="Please note that tasks inactive for 3+ months are hidden automatically. Toggle to view."
                tooltipPlacement="bottom"></span>
              Show hidden tasks
            </label>
            <div class="form-check form-switch mx-10">
              <input
                type="checkbox"
                class="form-check-input medium"
                [(ngModel)]="hiddenMode"
                (ngModelChange)="onChangeHiddenMode()"
                [ngModelOptions]="{ standalone: true }" />
            </div>
          </div>
        }
        <div
          class="d-flex justify-content-between align-items-center"
          *ngIf="this.usersService.authUser?.role !== Role.SUB || this.usersService.authUser?.showAllResults">
          <label class="label">Show my tasks only</label>
          <div class="form-check form-switch mx-10">
            <input
              type="checkbox"
              class="form-check-input medium"
              [(ngModel)]="showMyTasks"
              (ngModelChange)="onShowMyTasksFlag()"
              [ngModelOptions]="{ standalone: true }" />
          </div>
        </div>
      </div>
    </div>

    <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
      <app-scheduler-table
        [taskView]="activeTasksView()"
        (actions)="schedulerAction($event)"
        (selectionChange)="onSelectionChange($event)"></app-scheduler-table>

      @if (selectedTasks().length) {
        <div class="table-action-info-bar">
          <div class="info-left">
            <div class="text-icon-holder" tabindex="0" (keyup.enter)="batchClear()" (click)="batchClear()">
              <span class="icon">
                <span class="selected icon-done"></span>
              </span>
              <span class="text">{{ selectedTasks().length }} Selected</span>
            </div>
          </div>
          <div class="info-right">
            <button class="btn ghost-btn btn-action text-icon-holder" [disabled]="selectedStoppableTasks().length === 0" (click)="onClickBulkStop()">
              <span class="icon">
                <span class="far fa-stop-circle fs-4"></span>
              </span>
              <span class="text">Stop</span>
            </button>
            <button class="btn ghost-btn btn-action text-icon-holder" [disabled]="selectedPausableTasks().length === 0" (click)="onClickBulkPause()">
              <span class="icon">
                <span class="fas fa-pause fs-5"></span>
              </span>
              <span class="text">Pause</span>
            </button>
            <button
              class="btn ghost-btn btn-action text-icon-holder"
              [disabled]="selectedResumableTasks().length === 0"
              (click)="onClickBulkResume()">
              <span class="icon">
                <span class="fas fa-play fs-6"></span>
              </span>
              <span class="text">Resume</span>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<ng-template #schedulerCreateModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Create schedule</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <app-scheduler-create (onScheduleAfterSave)="onScheduleAfterSave()"></app-scheduler-create>
  </div>
</ng-template>

<ng-template #schedulerStopTaskModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Would you like to stop the current task?</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(null)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <p>If you would like to replace the current task with the cloned one, click 'Yes'.</p>
    <p>Otherwise, both scheduled tasks will be running.</p>
  </div>

  <div class="modal-footer pt-15 d-flex justify-content-between align-items-center">
    <a role="button" class="btn btn-outline-dark px-15" (click)="dialogRef.close(false)">No</a>
    <button class="btn btn-primary px-15" type="submit" (click)="dialogRef.close(true)">Yes</button>
  </div>
</ng-template>

<!-- ── Bulk action confirmation modal ───────────────────────────────────── -->
<ng-template #schedulerBulkActionTaskModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">{{ bulkActionModalTitle() }}</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <p>{{ bulkActionModalDescription() }}</p>
    <div class="bulk-task-ids-wrapper">
      <textarea class="bulk-task-ids-textarea" [value]="bulkActionTaskIdsString()" readonly rows="1"></textarea>
    </div>
  </div>
  <div class="modal-footer pt-15 d-flex justify-content-between align-items-center">
    <a role="button" class="btn btn-outline-dark px-15" (click)="dialogRef.close(false)">Cancel</a>
    <button class="btn btn-primary px-15" type="submit" (click)="dialogRef.close(true)">
      {{ bulkActionModalConfirmText() }}
    </button>
  </div>
</ng-template>
